module.exports = __webpack_public_path__ + "html/section-horizontal-image-text_609bd070afd512aefd90cd9dfbe1415f.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-horizontal-image-text.html
// module id = Ru63
// module chunks = 62